/* eslint-disable import/prefer-default-export */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable import/first */
import { updateState } from 'helpers/utils';
import { getCartCount, getCart } from '../../sidecart';
import { API, fetchCart } from 'helpers/api';
import swal from 'sweetalert'

export const order = {
    state: {
        Search: {
            Term: '',
            Type: 'OB',
            DropDown: false,
            Part: {},
            Selected: false,
            Results: [],
        },
        CrossReference: {
            SelectedPart: {},
            Show: false,
            Parts: [],
            NoResults: false,
            ClosestMatching: false,
        },
        Modal: {
            Show: false,
            Data: {},
        },
        Order: {
            Show: true,
            Total: 0.0,
            List: [],
            OrderInitialized: false,
        },
        isAlternateWarehouseDisabled: false,
        disableSmartShip: false,
        ActiveItemCount: 0,
        InActiveItemCount: 0,
        MaxCartItems: 0,
        isAlternateWarehouseLoading: false,
        alternativeParts: [],
    },
    mutations: {
        UpdateSearch(state, payload) {
            updateState(state, payload, 'Search');
        },
        UpdateCrossReference(state, payload) {
            updateState(state, payload, 'CrossReference');
        },
        ToggleCrossReference(state) {
            state.CrossReference.Show = !state.CrossReference.Show;
        },
        UpdateModal(state, payload) {
            updateState(state, payload, 'Modal');
        },
        ToggleModal(state) {
            state.Modal.Show = !state.Modal.Show;
        },
        InitOrder(state, order) {
            state.Order.List = order.reverse();
            state.Order.OrderInitialized = !state.Order.OrderInitialized;
        },
        SetAlternativeParts(state, parts) {
            state.alternativeParts = parts;
        },
        updateAlternativeParts(state, alternativeParts) {
            state.alternativeParts.push(...alternativeParts);
        },
        UpdateOrder(state, part) {
            const index = state.Order.List.findIndex((item) => {
                return item.Product.CartItemId === part.Part.Product.CartItemId;
            });
            if (part.Remove && index >= 0) {
                state.Order.List.splice(index, 1);
            } else if (index >= 0 && !part.Part.Product.IsNLA) {
                state.Order.List[index].Quantity = part.Part.Quantity;
                state.Order.List[index].Product = part.Part.Product;
                state.Order.List[index].Product.PartNote = part.Part.Product.PartNote;
            } else {
                state.Order.List.unshift(part.Part);
            }
        },
        UpdateTotal(state) {
            state.Order.Total = 0;
            for (let i = 0; i < state.Order.List.length; i++) {
                if (
                    !state.Order.List[i].Product.IsNLA &&
                    state.Order.List[i].Product.CartItemId !== 0
                ) {
                    state.Order.Total +=
                        state.Order.List[i].Product.ActualCost * state.Order.List[i].Quantity;
                }
            }
        },
        UpdateItemsCount(state, data) {
            state.MaxCartItems = data.MaxCartItems;
            state.ActiveItemCount = data.ActiveItemCount;
            state.InActiveItemCount = data.InActiveItemCount;
        },
        ClearOrder(state) {
            state.Order.List = [];
        },
        clearCcrr(state) {
            state.CrossReference.Parts = [];
        },
        setAlternateWarehouseLoading(state, payload) {
            state.isAlternateWarehouseLoading = payload;
        },
        updateAlternateWarehouseQTY(state, part) {
            // Find the product in the order list by its ID
            const productIndex = state.Order.List.findIndex(
                (orderItem) =>
                    orderItem.Product.Id === part.Product.Id &&
                    orderItem.DefaultWarehouseLocationId === orderItem.SelectedWarehouseLocationId, //only update the original product
            );

            if (productIndex !== -1) {
                // Product found, now find the specific stock information
                const stockIndex = state.Order.List[productIndex].Product.AllStockInfo.findIndex(
                    (stockInfo) => stockInfo.LOCATION_ID === part.SelectedWarehouseLocationId,
                );

                if (stockIndex !== -1) {
                    // Stock information found, update the AVAILABLE_COUNT
                    state.Order.List[productIndex].Product.AllStockInfo[
                        stockIndex
                    ].AVAILABLE_COUNT += part.Quantity;
                } else {
                    console.log(
                        'Stock information not found for location ID:',
                        part.SelectedWarehouseLocationId,
                    );
                }
            } else {
                //try to find it in alternative part
                const altProductIndex = state.alternativeParts.findIndex(
                    (altPart) => altPart.Product.Id === part.Product.Id,
                );

                if (altProductIndex !== -1) {
                    // Product found in alternative parts, now find the specific stock information
                    const altStockIndex = state.alternativeParts[
                        altProductIndex
                    ].Product.AllStockInfo.findIndex(
                        (stockInfo) => stockInfo.LOCATION_ID === part.SelectedWarehouseLocationId,
                    );

                    if (altStockIndex !== -1) {
                        state.alternativeParts[altProductIndex].Product.AllStockInfo[
                            altStockIndex
                        ].AVAILABLE_COUNT += part.Quantity;
                    } else {
                        console.log(
                            'Stock information not found in alternative parts for location ID:',
                            part.SelectedWarehouseLocationId,
                        );
                    }
                } else {
                    console.log('Product not found in order list with ID:', part.Product.Id);
                }
            }
        },
    },
    actions: {
        async Autocomplete(context, payload) {
            const searchUpdate = { Term: payload.Term, Type: payload.Type };
            if (payload.force) {
                searchUpdate.Results = [];
            }
            context.commit('UpdateSearch', searchUpdate);
            let res = [];

            if (payload.Term && payload.Term.trim()) {
                res =
                    context.state.Search.Type === 'CR'
                        ? await API.crossref.autocomplete(payload.Term)
                        : await API.product.autocomplete(payload.Term);
                if (!res.length) {
                    res = context.state.Search.Results;

                    if (context.state.Search.Results.length === 1) {
                        order.state.CrossReference.NoResults = true;
                        order.state.CrossReference.ClosestMatching = true;
                    }
                } else {
                    order.state.CrossReference.NoResults = false;
                    order.state.CrossReference.ClosestMatching = false;
                }
            }
            const retVal = { DropDown: !!res.length };
            if (res.length) {
                retVal.Results = res;
            }
            context.commit('UpdateSearch', retVal);
        },
        async UpdateCrossReference(context) {
            context.commit('UpdateSearch', { DropDown: false });
            if (context.state.Search.Part.Product.Id) {
                const res = await API.crossref.detail(context.state.Search.Part.Product.Id);
                if (res.notify) {
                    context.commit('UpdateCrossReference', {
                        Show: true,
                        Parts: [],
                        SelectedPart: context.state.Search.Part,
                    });
                } else {
                    context.commit('UpdateCrossReference', {
                        Show: !!(res.CheckStocks && res.CheckStocks.length),
                        Parts: res.CheckStocks,
                        SelectedPart: context.state.Search.Part,
                    });
                }
            }
        },
        async InitOrder(context) {
            const res = await fetchCart();
            if (!res.error) {
                context.state.disableSmartShip =
                    res.User.NetSuiteCustomer.Disable_Warehouse_Auto_Select === 'T';
            }

            const response = await API.cart.getInactive();
            if (!response.error) {
                // Check if response contains 'isAlternateWarehouseDisabled'
                if (response.hasOwnProperty('isAlternateWarehouseDisabled')) {
                    const { retVal, isAlternateWarehouseDisabled, alternativeParts } = response;
                    context.commit('InitOrder', retVal);
                    context.state.isAlternateWarehouseDisabled = isAlternateWarehouseDisabled;
                    context.commit('SetAlternativeParts', alternativeParts);
                } else {
                    context.commit('InitOrder', response);
                }

                context.commit('UpdateTotal');
            }
        },
        async OrderUpdate(context, state) {
            const res = await API.cart.updateQuantity(
                state.Product.CartItemId,
                state.Quantity,
                state.Product.PartNote,
            );
            if (!res.error) {
                state.Product.SmartshipQuantity = res.Product.SmartshipQuantity;
                state.Product.BackorderQuantity = res.Product.BackorderQuantity;
                state.Product.ActualCost = res.Product.ActualCost;
                state.Product.Availability = res.Product.Availability;
                state.Quantity = res.Quantity;
                context.commit('UpdateOrder', { Remove: false, Part: state });
                context.commit('UpdateTotal');
            }
        },
        async OrderAdd(context, part) {
            context.commit('UpdateSearch', {
                Term: ``,
                Part: {},
                Selected: false,
                DropDown: false,
            });
            let partNoteMessage = '';
            if (order.state.Search.Type === 'CR') {
                const partSelected = order.state.CrossReference.SelectedPart.Product;
                partNoteMessage = `Replacement Part for ${partSelected.ManufacturerCode}, ${partSelected.PartNumber}`;
            }
            const partQuantity = part.Quantity ? part.Quantity : 1;

            const res = await API.product.get(
                part.Product.Id,
                partQuantity,
                'regular',
                partNoteMessage,
                0, //locationId
                true, //include alternative part
            );

            if (!res.error) {
                const mainProducts = res.MainProducts;
                const alternativeParts = res.AlternativeParts;

                for (let i = 0; i < mainProducts.length; i++) {
                    context.commit('UpdateOrder', { Remove: false, Part: mainProducts[i] });
                    if (mainProducts[i].Product.IsProhibitedState) {
                        swal("Restricted Part Note", mainProducts[i].Product.RestrictedPartNote, "info");
                    }
                }

                if (alternativeParts && alternativeParts.length > 0) {
                    context.commit('updateAlternativeParts', alternativeParts);
                }

                context.commit('UpdateTotal');
                context.commit('UpdateSearch', { Results: [] });
            }
        },
        async AlternateWarehouseOrderAdd(context, payload) {
            context.commit('setAlternateWarehouseLoading', true); // Start loading

            const { part, locationId, quantity, selectedPartForPopup } = payload;

            const res = await API.product.get(
                part.Id,
                quantity,
                'regular',
                '', //partNoteMessage
                locationId,
                false, // includeAlternativePart
            );

            if (!res.error) {
                for (let i = 0; i < res.length; i++) {
                    context.commit('UpdateOrder', { Remove: false, Part: res[i] });
                }
                context.commit('UpdateTotal');
                context.commit('UpdateSearch', { Results: [] });

                // substrack original. If quantity < 0, remove
                if (selectedPartForPopup.Quantity > 0) {
                    var newQuantity = selectedPartForPopup.Quantity - quantity;
                    if (newQuantity <= 0) {
                        selectedPartForPopup.Quantity = newQuantity;
                        context.dispatch('OrderRemove', selectedPartForPopup);
                    } else {
                        selectedPartForPopup.Quantity = newQuantity;
                        part.Quantity = newQuantity;
                        context.dispatch('OrderUpdate', selectedPartForPopup);
                    }
                }
            }

            context.commit('setAlternateWarehouseLoading', false); // Stop loading
        },
        async AlternativePartOrderAdd(context, payload) {
            context.commit('setAlternateWarehouseLoading', true); // Start loading

            const { part, locationId, quantity, selectedPartForPopup } = payload;

            const res = await API.product.get(
                part.Id,
                quantity,
                'regular',
                '', //partNoteMessage
                locationId,
                false, // includeAlternativePart
            );

            if (!res.error) {
                for (let i = 0; i < res.length; i++) {
                    context.commit('UpdateOrder', { Remove: false, Part: res[i] });
                }
                context.commit('UpdateTotal');
                context.commit('UpdateSearch', { Results: [] });
            }
            context.commit('setAlternateWarehouseLoading', false); // Stop loading
        },
        async UpdateItemsCount(context, cartType = 'regular') {
            const res = await API.product.getItemsCount(cartType);
            if (!res.error) {
                context.commit('UpdateItemsCount', {
                    MaxCartItems: res.MaxCartItems,
                    ActiveItemCount: res.ActiveItemCount,
                    InActiveItemCount: res.InActiveItemCount,
                });
            }
        },
        async OrderRemove(context, part) {
            const items = [];
            items.push(`${part.Product.CartItemId}`);
            const res = await API.cart.delete(items, 'order-builder:OrderRemove');
            if (!res.error) {
                context.commit('UpdateOrder', { Remove: true, Part: part });
                context.commit('UpdateTotal');
                context.commit('updateAlternateWarehouseQTY', part);
            }
        },
        async OrderRemoveAll(context) {
            const res = await API.cart.emptyCart();
            if (!res.error) {
                context.commit('ClearOrder');
                context.commit('UpdateTotal');
            }
        },
        async OrderAddToCart(context, part) {
            const parts = [];
            const index = context.state.Order.List.findIndex(
                (item) =>
                    item.Product.Id === part.Product.Id &&
                    item.SelectedWarehouseLocationId == part.SelectedWarehouseLocationId,
            );
            if (index >= 0) {
                parts.push({
                    cartItemId: context.state.Order.List[index].Product.CartItemId,
                    qty: context.state.Order.List[index].Quantity,
                    note: context.state.Order.List[index].Product.PartNote,
                    ActiveItemCount: context.state.Order.ActiveItemCount, //.List[index].Product.PartNote,
                    InActiveItemCount: context.state.Order.InActiveItemCount, //.List[index].Product.PartNote,
                    DefaultWarehouseLocationId:
                        context.state.Order.List[index].DefaultWarehouseLocationId,
                    SelectedWarehouseLocationId:
                        context.state.Order.List[index].SelectedWarehouseLocationId,
                    AvailabilityNotes: context.state.Order.List[index].Product.AvailabilityNotes,
                });

                const res = await API.cart.add(parts);
                if (!res.error) {
                    context.commit('UpdateOrder', { Remove: true, Part: part });
                    context.commit('UpdateTotal');
                    getCartCount();
                    getCart();
                }
            }
        },
        async OrderAddAllToCart(context) {
            const parts = [];
            for (let i = 0; i < context.state.Order.List.length; i++) {
                parts.push({
                    cartItemId: context.state.Order.List[i].Product.CartItemId,
                    qty: context.state.Order.List[i].Quantity,
                    note: context.state.Order.List[i].Product.PartNote,
                    DefaultWarehouseLocationId:
                        context.state.Order.List[i].DefaultWarehouseLocationId,
                    SelectedWarehouseLocationId:
                        context.state.Order.List[i].SelectedWarehouseLocationId,
                    AvailabilityNotes: context.state.Order.List[i].Product.AvailabilityNotes,
                });
            }

            if (!parts.length) {
                return;
            }

            const res = await API.cart.add(parts);
            if (!res.error) {
                context.commit('ClearOrder');
                context.commit('UpdateTotal');
                getCartCount();
                getCart();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./app/js/modules/vue/modules/order-builder.js